import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";
import tokenService from '../../Common/tokenDecoder';

export default {
    getAll,
    getEstatesByGroupID,
    GetAllCashWorkType,
    GetTemporaryCardDetails,
    UpdateTemporaryCardDetails,
    getCollectionPointByGroupEntityID,
};

async function getAll() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllCashWorkType() {
    const response = await CommonGet('/api/UpdateTemporaryCards/GetAllCashWorkType', null);
    let cashWorkTypeArray = []
    for (let item of Object.entries(response.data)) {
        cashWorkTypeArray[item[1]["cashWorkTypeID"]] = item[1]["cashWorkTypeName"]
    }
    return cashWorkTypeArray;
}

async function getEstatesByGroupID(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllFactoryFilteredOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointByGroupEntityID(factoryID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllRouteByFactoryIDV2', 'factoryID=' + factoryID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return array;
}

async function GetTemporaryCardDetails(model) {
    const response = await CommonPost('/api/UpdateTemporaryCards/GetTemporaryCardData', null, model);
    return response;
}

async function UpdateTemporaryCardDetails(saveData) {
    const response = await CommonPost('/api/UpdateTemporaryCards/UpdateTemporaryCardData', null, saveData);
    return response;
}